import { defineStore } from 'pinia';
import type { BundleDissolutionScenario } from '@apps-once/definitions';

type BundleDissolutionState = {
  status: { isVisible: boolean };
  scenario: BundleDissolutionScenario | null;
  addOnId: string | null;
  // Carried through so the proceed handler can re-open the cancel modal with
  // the right trial flag — the add-on store isn't primed until after the
  // warning is confirmed.
  isTrial: boolean;
};

export const useBundleDissolutionStore = defineStore('bundleDissolution', {
  state: (): BundleDissolutionState => ({
    status: { isVisible: false },
    scenario: null,
    addOnId: null,
    isTrial: false,
  }),
  actions: {
    open(
      scenario: BundleDissolutionScenario,
      addOnId: string | null = null,
      isTrial = false
    ) {
      this.scenario = scenario;
      this.addOnId = addOnId;
      this.isTrial = isTrial;
      this.status.isVisible = true;
    },
    close() {
      this.status.isVisible = false;
      this.scenario = null;
      this.addOnId = null;
      this.isTrial = false;
    },
  },
});
